export default __webpack_public_path__ + "static/media/main_fondo.31488ef3.png";